// Narrows an unknown value (e.g. parsed JSON) to an object whose properties can be read
export const isRecord = (value: unknown): value is Record<string, unknown> => (
    typeof value === 'object' && value !== null && ! Array.isArray(value)
)
